import React, {Component} from 'react'
import DefaultTab from './DefaultTab'
import {connect} from 'react-redux'
import { alert } from 'util/alert';
import { CountBadge } from 'components/UI'
import CreateTeacherModal from 'template/Modals/CreateTeacher'
import { getSubscription } from 'containers/Main/ducks/subscription';
import __R from 'containers/__R';
import FilterBy from 'template/FilterBy';
import {fetchTeacher} from './ducks'
import locale from './locale'
import './Teacher.scss'

import {
  Button,
	PanelWrapper,
	Tab,
	Tabs,
	TabList,
	TabPanel,
} from 'components/UI'

const FILTERS = ['text:searchKeyword'];

const FILTER_OPTIONS = {
  'text:searchKeyword': {
    placeholder: __('Search Teacher', locale),
    valueMinLength: 2,
  }
}
const mapStateToProps = (state) => ({
  gSubscription: state.gSubscription,
  teacherList: state.teacherList,
})

const mapDispatchToProps = (dispatch) => {
	return {
    fetchTeacher: (opts, state) => dispatch(fetchTeacher(opts, state)),
    getSubscription: (schoolId)=> dispatch(getSubscription(schoolId))
	};
};

class Teacher extends Component {
  constructor(props){
    super(props)

    this.state = {
      currentTeacherCount: 0,
      archivedTeacherCount: 0,
      options: [],
      selectedOption: '',
      selectedIndex: 0,
      orderBy: 0,
      filterData:{},
      keyword: ''
    }

    this.onFilterChange = this.onFilterChange.bind(this)
    this.onSelectTab = this.onSelectTab.bind(this)
    this.addNewTeacher = this.addNewTeacher.bind(this)
  }

  componentWillMount(){
    // temporary solution to redirect to deleted teacher tab when exit out of teacher attendance
    if(window.location.search == '?tab=1'){
      this.setState({selectedIndex: 1})
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.teacherList) {
      const {
        fetching,
        teacherState,
        pagination
      } = nextProps.teacherList;
      const { totalItemsCount } = pagination;
      // for a breif moment, when fetching is true, the count can be a number
      // from the previous state
      if (teacherState == 'current' && fetching == false) {
        this.setState({
          currentTeacherCount: totalItemsCount,
        });
      }else if(teacherState == 'archived' && fetching == false) {
        this.setState({
          archivedTeacherCount: totalItemsCount,
        });
      }
    }
  }

  onFilterChange({ filterData }){
    const schoolId = localStorage.getItem('schoolId')
    const {selectedIndex, orderBy} = this.state
    const {pagination} = this.props.teacherList;
    const {activePage, itemsCountPerPage} = pagination;
    let teacherState = selectedIndex == 0 ? 'current' : 'archived';

    this.setState({
      filterData,
      keyword: filterData['searchKeyword']
    },
      ()=>{
        this.props.fetchTeacher({
          schoolId,
          amount_per_page: itemsCountPerPage,
          current_page_number: activePage,
          order_by: orderBy,
          keyword: this.state.keyword
        }, teacherState)
      }
    )
  }
  addNewTeacher(){
    const {selectedIndex, orderBy} = this.state;
    const teacherState = selectedIndex == 0 ? 'current' : 'archived';
    const {teacherList, gSubscription, getSubscription} = this.props
    const {pagination} = teacherList;
    const {is_valid, maximum_amount, existing_amount, saas_version} = gSubscription.result;
    const {maximum_teacher} = maximum_amount;
    const {teacher_amount} = existing_amount;
    const {activePage, itemsCountPerPage} = pagination;
    const schoolId = localStorage.getItem('schoolId')

    if(is_valid && (saas_version === 1 || maximum_teacher===null || teacher_amount<maximum_teacher)){
      CreateTeacherModal({mode: 'create'})
      .then(() => {
        getSubscription(schoolId);
        this.setState({
          filterData: {
            ...this.state.filterData,
            searchKeyword: '',
          },
          keyword: ''
        },()=>{
          this.props.fetchTeacher({
            schoolId,
            amount_per_page: itemsCountPerPage,
            current_page_number: activePage,
            order_by: orderBy,
          }, teacherState)
        })
      })
    } else {
      alert.message(__('You are about go over the teacher limit, please upgrade to higher subscription plan to add more teachers', 'header'), __('Upgrade Subscription Plan', 'header'))
    }
  }
  renderAddTeacherButton(){
    return(
      <__R can="create_teacher" by='disable'>
        <Button bsStyle='primary' className="pull-right createBtn" onClick={()=>{
          this.addNewTeacher();
        }}>
        {__('New Teacher', locale)}
        </Button>
      </__R>
    )
  }

  onSelectTab(selectedIndex){
    const { orderBy } = this.state;

    this.setState({
      selectedIndex, 
      orderBy: orderBy, 
      filterData: {
        ...this.state.filterData,
        searchKeyword: '',
      },
      keyword: ''
    })
  }

  render(){
    const schoolId = localStorage.getItem('schoolId')
    const {activePage, itemsCountPerPage} = this.props.teacherList.pagination;
    const {currentTeacherCount, archivedTeacherCount, selectedIndex, selectedOption, filterData, keyword, orderBy} = this.state;
    let teacherState = selectedIndex == 0 ? 'current' : 'archived';

    return(
      <PanelWrapper className='teacher-container'>
        <div>
          {__("Teacher List", "teacher")}
        </div>
        <Tabs defaultIndex={selectedIndex} onSelect={this.onSelectTab}>
          <TabList>
            <Tab>
              {__('Current', locale)}
              { (currentTeacherCount > 0 && selectedIndex==0) && <CountBadge>{currentTeacherCount}</CountBadge> }
            </Tab>
            <Tab>{__('Archived', locale)}
              { (archivedTeacherCount > 0 && selectedIndex==1) && <CountBadge>{archivedTeacherCount}</CountBadge> }
            </Tab>
            {this.renderAddTeacherButton()}
            <div className='pull-right'>
              <FilterBy
                filterData={filterData}
                filters={FILTERS}
                options={FILTER_OPTIONS}
                onChange={this.onFilterChange} />
            </div>
            <select className='form-control sort-by pull-right' value={orderBy} disabled={selectedOption} onChange={(e) => {
              this.setState({orderBy: e.target.value}, ()=>{
                this.props.fetchTeacher({
                  schoolId,
                  amount_per_page: itemsCountPerPage,
                  current_page_number: activePage,
                  order_by: this.state.orderBy,
                  keyword
                }, teacherState)
              })
            }}>
              <option key='0' value='0'>{__('Creation Time: Newest to Oldest', locale)}</option>
              <option key='1' value='1'>{__('Creation Time: Oldest to Newest', locale)}</option>
              <option key='2' value='2'>{__('Name: A-Z', locale)}</option>
              <option key='3' value='3'>{__('Name: Z-A', locale)}</option>
            </select>
            <div className='pull-right sort-by-label'>{__('Sort by', locale)}</div>
          </TabList>

          <TabPanel>
            <DefaultTab teacherState={'current'} orderBy={orderBy} keyword={keyword}/>
          </TabPanel>
          <TabPanel>
            <DefaultTab  teacherState={'archived'} orderBy={orderBy} keyword={keyword}/>
          </TabPanel>
        </Tabs>
      </PanelWrapper>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Teacher)



// WEBPACK FOOTER //
// ./src/containers/pages/Teacher/index.js